// extracted by mini-css-extract-plugin
export default {"opinion":"zZ3SLAQq","quotes":"lH5mLdHL","body":"hRLtb7IJ","link":"ccP7h7F4","authorAnimated":"ntCdQpQ5","content":"ftaYBcM6","mobile":"mobile"};